(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/views/drawselector.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/views/drawselector.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.sport=_svs.sport||{};
_svs.sport.drawselector=_svs.sport.drawselector||{};
_svs.sport.drawselector.templates=_svs.sport.drawselector.templates||{};
svs.sport.drawselector.templates.drawselector = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"drawselector\">\n    <div id=\"drawselector-header\"></div>\n    <div id=\"drawselector-list\"></div>\n</div>\n";
},"useData":true});
Handlebars.partials['components-sport-drawselector-drawselector'] = svs.sport.drawselector.templates.drawselector;
})(svs, Handlebars);

 })(window);